import React from 'react';
import {Icon} from 'antd';
import {Link} from 'react-router-dom';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const edoProviders = [
    {
        name: 'Астрал.Доки',
        links: [
            {
                label: 'Открыть личный кабинет',
                href: 'https://identity.astral.ru/Account/classic?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Donecdocs%26scope%3Dopenid%2520offline_access%2520personarea_personal%2520personarea_contact%2520personarea_certificates%2520payment%2520editor%26response_type%3Dcode%26redirect_uri%3Dhttps%253A%252F%252F1cdocs.ru%252Fauth%252Fcb'
            },
            {
                label: 'Инструкция по настройке',
                href: 'https://astral.ru/help/doki/'
            }
        ]
    },
    {
        name: 'СБИС',
        links: [
            {
                label: 'Открыть личный кабинет',
                href: 'https://online.sbis.ru/auth/?tab=register&agent=5200'
            },
            {
                label: 'Инструкция по входу',
                href: 'https://saby-sbis.ru/lk-sbis-online-vhod'
            }
        ]
    }
];


const edoSettingsItems = [
    {
        id: 'cabinet',
        number: 1,
        content: (
            <>
                Перейдите в раздел <strong>«Кабинет»</strong>.
            </>
        ),
        area: {
            top: 1.5,
            left: 34.3,
            width: 5.7,
            height: 6.5
        }
    },
    {
        id: 'edo-settings',
        number: 2,
        content: (
            <>
                Откройте вкладку
                <strong> «Настройки ЭДО»</strong>.
            </>
        ),
        area: {
            top: 90.86,
            left: 3.06,
            width: 21.79,
            height: 5.76
        }
    },
    {
        id: 'edo-tab',
        number: 3,
        content: (
            <>
                Выберите вкладку <strong>«ЭДО»</strong>.
            </>
        ),
        area: {
            top: 33,
            left: 26.5,
            width: 5.7,
            height: 7
        }
    },
    {
        id: 'authorize',
        number: 4,
        content: (
            <>
                Нажмите кнопку <strong>«Авторизоваться» </strong>
                и войдите с данными учётной записи оператора ЭДО.
            </>
        ),
        area: {
            top: 53.21,
            left: 67.43,
            width: 26.68,
            height: 4.21
        }
    },
    {
        id: 'edo-subscriber',
        number: 5,
        content: (
            <>
                После авторизации убедитесь, что организация
                появилась в разделе <strong>«Абоненты ЭДО»</strong>.
            </>
        ),
        area: {
            top: 77.8,
            left: 26.4,
            width: 68.5,
            height: 15
        }
    }
];


const sendDocumentItems = [
    {
        id: 'send-document',
        number: 1,
        content: (
            <>
                Под нужным документом нажмите кнопку
                <strong> «Отправить в ЭДО»</strong>.
            </>
        ),
        area: {
            top: 76.98,
            left: 6.7,
            width: 86.95,
            height: 10.65
        }
    }
];


const recipientItems = [
    {
        id: 'operator',
        number: 2,
        content: (
            <>
                Выберите оператора электронного документооборота.
            </>
        ),
        area: {
            top: 34,
            left: 4.2,
            width: 91.5,
            height: 10
        }
    },
    {
        id: 'recipient',
        number: 3,
        content: (
            <>
                Выберите получателя документа.
            </>
        ),
        area: {
            top: 62,
            left: 4.2,
            width: 91.5,
            height: 10
        }
    },
    {
        id: 'send',
        number: 4,
        content: (
            <>
                Нажмите кнопку <strong>«Отправить»</strong>.
            </>
        ),
        area: {
            top: 86,
            left: 41.3,
            width: 18.7,
            height: 11
        }
    }
];


const missingRecipientItems = [
    {
        id: 'missing-recipient',
        number: 3,
        content: (
            <>
                Если подходящий получатель не найден,
                его можно выбрать позже в системе ЭДО.
            </>
        ),
        area: {
            top: 59,
            left: 4,
            width: 76,
            height: 11
        }
    },
    {
        id: 'send-without-recipient',
        number: 4,
        content: (
            <>
                Нажмите кнопку <strong>«Отправить»</strong>,
                чтобы сохранить документ без получателя.
            </>
        ),
        area: {
            top: 83.93,
            left: 41.2,
            width: 18.84,
            height: 11.81
        }
    }
];


const openEdoItems = [
    {
        id: 'open-edo',
        number: 5,
        content: (
            <>
                Нажмите кнопку <strong>«Перейти в ЭДО»</strong>,
                подпишите документ и отправьте его контрагенту.
            </>
        ),
        area: {
            top: 62.91,
            left: 4.43,
            width: 90.36,
            height: 16.37
        }
    }
];


export default function Edo() {
    return (
        <InstructionLayout title="Электронный документооборот">
            <p className="instruction-intro">
                На платформе реализована интеграция с системами
                электронного документооборота. Через ЭДО можно
                подписывать договоры, заявки на рейсы, доверенности,
                акты и счета.
            </p>

            <div className="instruction-callout">
                <div className="instruction-callout__content">
                    <strong className="instruction-callout__title">
                        Быстрый переход к настройкам ЭДО
                    </strong>

                    <p className="instruction-callout__text">
                        Если вы уже знакомы с подключением электронного
                        документооборота, перейдите сразу к авторизации
                        и управлению ЭДО.
                    </p>
                </div>

                <Link
                    className="instruction-callout__link"
                    to="/company/epd-astral"
                >
                    Перейти к настройкам
                </Link>
            </div>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="file-text"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Юридически значимый документооборот
                    </strong>

                    <p className="service-highlight__text">
                        Документы передаются в подключённую систему ЭДО,
                        где их можно проверить, подписать и отправить
                        контрагенту.
                    </p>
                </div>
            </div>

            <h2 className="instruction-section-title">
                Как начать работу с ЭДО
            </h2>

            <InstructionStep
                number="1"
                title="Зарегистрируйтесь в системе ЭДО"
            >
                <div className="instruction-copy">
                    <p>
                        Зарегистрируйте личный кабинет у оператора ЭДО,
                        если у вашей организации его ещё нет.
                    </p>

                    <div className="service-provider-grid">
                        {edoProviders.map((provider) => (
                            <section
                                className="service-provider-card"
                                key={provider.name}
                            >
                                <h3 className="service-provider-card__title">
                                    {provider.name}
                                </h3>

                                <div className="service-provider-card__links">
                                    {provider.links.map((link) => (
                                        <a
                                            key={link.href}
                                            href={link.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <span>
                                                {link.label}
                                            </span>

                                            <Icon type="link"/>
                                        </a>
                                    ))}
                                </div>
                            </section>
                        ))}
                    </div>

                    <p>
                        Добавьте в личный кабинет оператора вашу
                        организацию — юридическое лицо или ИП.
                    </p>

                    <p>
                        В разделе <strong>«Мои контрагенты»</strong>{' '}
                        укажите организации, с которыми планируете
                        обмениваться документами. Для добавления
                        потребуется ИНН и подтверждение связи
                        со стороны контрагента.
                    </p>
                </div>
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Подключите ЭДО на платформе"
            >
                <div className="instruction-copy">
                    <p>
                        Откройте настройки ЭДО, авторизуйтесь через
                        оператора и проверьте подключение организации.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/edo/01-edo-settings.png"
                    alt="Настройка и авторизация электронного документооборота"
                    items={edoSettingsItems}
                />
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Отправьте документ в ЭДО"
            >
                <div className="instruction-copy">
                    <p>
                        После подключения документы можно передавать
                        в ЭДО непосредственно с платформы.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/edo/02-edo-send-documents.png"
                    alt="Отправка счёта или акта в ЭДО"
                    items={sendDocumentItems}
                />

                <InstructionSpotlight
                    src="/img/instructions/edo/5.png"
                    alt="Выбор оператора и получателя документа"
                    items={recipientItems}
                />

                <div className="instruction-copy">
                    <p>
                        Если контрагент заранее добавлен в системе ЭДО,
                        он появится в списке доступных получателей.
                    </p>

                    <p>
                        Если получатель не найден, документ всё равно
                        можно передать в ЭДО и завершить его оформление
                        позднее.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/edo/6.png"
                    alt="Отправка документа без указанного получателя"
                    items={missingRecipientItems}
                />

                <div className="instruction-copy">
                    <p>
                        После загрузки документа откройте систему ЭДО
                        для завершения работы.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/edo/7.png"
                    alt="Переход в систему ЭДО для подписания документа"
                    items={openEdoItems}
                />
            </InstructionStep>
        </InstructionLayout>
    );
}